import styled from 'styled-components';
import { FormFieldMixin } from '../../mixins/components/FormFieldMixin';
export var StyledFieldSet = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "StyledFieldSet",
  componentId: "c11n-8-111-1__sc-151qck5-0"
})(["", ""], FormFieldMixin);